interface Props {
  file: File | null
  alt: string
  preview?: string | null
}

export function IconPreview({ file, preview }: Props) {
  if (preview && !file)
    return (
      <img
        src={preview}
        alt="Miniatura atual da lição"
        className="absolute top-0 w-full h-full"
      />
    )

  if (file)
    return (
      <img
        src={URL.createObjectURL(file)}
        className="absolute top-0 w-full h-full"
        alt=""
      />
    )

  return null
}
